// ******************************
// PRODUCT FILTERS
// ******************************

if (typeof window.htmx !== 'undefined') {

	function handleSprigError(event) {
		window.location.pathname = '/reactive-error'
	}

	window.htmx.on('htmx:responseError', handleSprigError);
	window.htmx.on('htmx:sendError', handleSprigError);
	window.htmx.on('htmx:swapError', handleSprigError);
	window.htmx.on('htmx:targetError', handleSprigError);
	window.htmx.on('htmx:timeout', handleSprigError);
}

// IMPORTANT: called from a twig template on sprig refresh, so needs to be available outside of the webpack library
window.initPriceRange = function () {

	const rangeSlider = document.getElementById('range-slider');
	if ( ! rangeSlider) return;

	const priceFrom = document.getElementById('price-from');
	const priceTo = document.getElementById('price-to');
	const start = parseInt(rangeSlider.dataset.start, 10);
	const end = parseInt(rangeSlider.dataset.end, 10);
	const max = parseInt(rangeSlider.dataset.max, 10);

	const priceFromIndicator = document.getElementById('price-from-indicator');
	const priceToIndicator = document.getElementById('price-to-indicator');

	// essential a reset, called when clearing filters
	if (rangeSlider.noUiSlider) {
		rangeSlider.noUiSlider.destroy();
		priceFrom.value = start;
		priceTo.value = max;
	}

	noUiSlider.create(rangeSlider, {
		start: [start, end],
		step: 10,
		range: {
			'min': [0],
			'max': [max]
		}
	});

	function formatCurrency(num) {
		return '£' + num.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
	}

	rangeSlider.noUiSlider.on('set', function (values) {
		const from = Number(values[0]);
		const to = Number(values[1]);
		priceFrom.value = from.toFixed();
		priceTo.value = to.toFixed();
		priceFromIndicator.innerText = formatCurrency(from);
		priceToIndicator.innerText = formatCurrency(to);
		const e = new Event("change");
		priceFrom.dispatchEvent(e);
	});

}
initPriceRange();

function filterTrigger () {
	$('.js-mobile-filter-trigger').click(function() {
		$('.filters').toggleClass('filters--active');
	});
}
filterTrigger();

window.unsetFilters = function() {

	function unsetFilter (filters, isReset) {
		filters.each(function () {
			if (this.type === 'checkbox') {
				this.checked = false;
			} else {
				initPriceRange();
			}
		});
	}

	$('[data-remove-filter]').click(function () {

		const filterToUnset = $(this).data('remove-filter');

		if (filterToUnset === 'all') {
			const allFilters = $('[data-filter-id]');
			unsetFilter(allFilters, true);
		} else {
			const singleFilter = $('[data-filter-id="' + filterToUnset + '"]');
			unsetFilter(singleFilter, false);
		}

	});

}

function filterDraw () {
	if ($('.js-filter-draw-trigger')[0]) {
		$('.filters__draw').slideUp();
		$('.js-filter-draw-trigger').click(function() {
			$(this).siblings('.filters__draw').slideToggle();
			$(this).toggleClass('active');
		});
	}
}
filterDraw();

function phoneScroll () {
	if ($('.phone-scroll')[0]) {
		/*!
		* parallax.js v1.5.0 (http://pixelcog.github.io/parallax.js/)
		* @copyright 2016 PixelCog, Inc.
		* @license MIT (https://github.com/pixelcog/parallax.js/blob/master/LICENSE)
		*/
		!function(t,i,e,s){function o(i,e){var h=this;"object"==typeof e&&(delete e.refresh,delete e.render,t.extend(this,e)),this.$element=t(i),!this.imageSrc&&this.$element.is("img")&&(this.imageSrc=this.$element.attr("src"));var r=(this.position+"").toLowerCase().match(/\S+/g)||[];if(r.length<1&&r.push("center"),1==r.length&&r.push(r[0]),"top"!=r[0]&&"bottom"!=r[0]&&"left"!=r[1]&&"right"!=r[1]||(r=[r[1],r[0]]),this.positionX!==s&&(r[0]=this.positionX.toLowerCase()),this.positionY!==s&&(r[1]=this.positionY.toLowerCase()),h.positionX=r[0],h.positionY=r[1],"left"!=this.positionX&&"right"!=this.positionX&&(isNaN(parseInt(this.positionX))?this.positionX="center":this.positionX=parseInt(this.positionX)),"top"!=this.positionY&&"bottom"!=this.positionY&&(isNaN(parseInt(this.positionY))?this.positionY="center":this.positionY=parseInt(this.positionY)),this.position=this.positionX+(isNaN(this.positionX)?"":"px")+" "+this.positionY+(isNaN(this.positionY)?"":"px"),navigator.userAgent.match(/(iPod|iPhone|iPad)/))return this.imageSrc&&this.iosFix&&!this.$element.is("img")&&this.$element.css({backgroundImage:'url("'+this.imageSrc+'")',backgroundSize:"cover",backgroundPosition:this.position}),this;if(navigator.userAgent.match(/(Android)/))return this.imageSrc&&this.androidFix&&!this.$element.is("img")&&this.$element.css({backgroundImage:'url("'+this.imageSrc+'")',backgroundSize:"cover",backgroundPosition:this.position}),this;this.$mirror=t("<div />").prependTo(this.mirrorContainer);var a=this.$element.find(">.parallax-slider"),n=!1;0==a.length?this.$slider=t("<img />").prependTo(this.$mirror):(this.$slider=a.prependTo(this.$mirror),n=!0),this.$mirror.addClass("parallax-mirror").css({visibility:"hidden",zIndex:this.zIndex,position:"fixed",top:0,left:0,overflow:"hidden"}),this.$slider.addClass("parallax-slider").one("load",function(){h.naturalHeight&&h.naturalWidth||(h.naturalHeight=this.naturalHeight||this.height||1,h.naturalWidth=this.naturalWidth||this.width||1),h.aspectRatio=h.naturalWidth/h.naturalHeight,o.isSetup||o.setup(),o.sliders.push(h),o.isFresh=!1,o.requestRender()}),n||(this.$slider[0].src=this.imageSrc),(this.naturalHeight&&this.naturalWidth||this.$slider[0].complete||a.length>0)&&this.$slider.trigger("load")}!function(){for(var t=0,e=["ms","moz","webkit","o"],s=0;s<e.length&&!i.requestAnimationFrame;++s)i.requestAnimationFrame=i[e[s]+"RequestAnimationFrame"],i.cancelAnimationFrame=i[e[s]+"CancelAnimationFrame"]||i[e[s]+"CancelRequestAnimationFrame"];i.requestAnimationFrame||(i.requestAnimationFrame=function(e){var s=(new Date).getTime(),o=Math.max(0,16-(s-t)),h=i.setTimeout(function(){e(s+o)},o);return t=s+o,h}),i.cancelAnimationFrame||(i.cancelAnimationFrame=function(t){clearTimeout(t)})}(),t.extend(o.prototype,{speed:.2,bleed:0,zIndex:-100,iosFix:!0,androidFix:!0,position:"center",overScrollFix:!1,mirrorContainer:"body",refresh:function(){this.boxWidth=this.$element.outerWidth(),this.boxHeight=this.$element.outerHeight()+2*this.bleed,this.boxOffsetTop=this.$element.offset().top-this.bleed,this.boxOffsetLeft=this.$element.offset().left,this.boxOffsetBottom=this.boxOffsetTop+this.boxHeight;var t,i=o.winHeight,e=o.docHeight,s=Math.min(this.boxOffsetTop,e-i),h=Math.max(this.boxOffsetTop+this.boxHeight-i,0),r=this.boxHeight+(s-h)*(1-this.speed)|0,a=(this.boxOffsetTop-s)*(1-this.speed)|0;r*this.aspectRatio>=this.boxWidth?(this.imageWidth=r*this.aspectRatio|0,this.imageHeight=r,this.offsetBaseTop=a,t=this.imageWidth-this.boxWidth,"left"==this.positionX?this.offsetLeft=0:"right"==this.positionX?this.offsetLeft=-t:isNaN(this.positionX)?this.offsetLeft=-t/2|0:this.offsetLeft=Math.max(this.positionX,-t)):(this.imageWidth=this.boxWidth,this.imageHeight=this.boxWidth/this.aspectRatio|0,this.offsetLeft=0,t=this.imageHeight-r,"top"==this.positionY?this.offsetBaseTop=a:"bottom"==this.positionY?this.offsetBaseTop=a-t:isNaN(this.positionY)?this.offsetBaseTop=a-t/2|0:this.offsetBaseTop=a+Math.max(this.positionY,-t))},render:function(){var t=o.scrollTop,i=o.scrollLeft,e=this.overScrollFix?o.overScroll:0,s=t+o.winHeight;this.boxOffsetBottom>t&&this.boxOffsetTop<=s?(this.visibility="visible",this.mirrorTop=this.boxOffsetTop-t,this.mirrorLeft=this.boxOffsetLeft-i,this.offsetTop=this.offsetBaseTop-this.mirrorTop*(1-this.speed)):this.visibility="hidden",this.$mirror.css({transform:"translate3d("+this.mirrorLeft+"px, "+(this.mirrorTop-e)+"px, 0px)",visibility:this.visibility,height:this.boxHeight,width:this.boxWidth}),this.$slider.css({transform:"translate3d("+this.offsetLeft+"px, "+this.offsetTop+"px, 0px)",position:"absolute",height:this.imageHeight,width:this.imageWidth,maxWidth:"none"})}}),t.extend(o,{scrollTop:0,scrollLeft:0,winHeight:0,winWidth:0,docHeight:1<<30,docWidth:1<<30,sliders:[],isReady:!1,isFresh:!1,isBusy:!1,setup:function(){function s(){if(p==i.pageYOffset)return i.requestAnimationFrame(s),!1;p=i.pageYOffset,h.render(),i.requestAnimationFrame(s)}if(!this.isReady){var h=this,r=t(e),a=t(i),n=function(){o.winHeight=a.height(),o.winWidth=a.width(),o.docHeight=r.height(),o.docWidth=r.width()},l=function(){var t=a.scrollTop(),i=o.docHeight-o.winHeight,e=o.docWidth-o.winWidth;o.scrollTop=Math.max(0,Math.min(i,t)),o.scrollLeft=Math.max(0,Math.min(e,a.scrollLeft())),o.overScroll=Math.max(t-i,Math.min(t,0))};a.on("resize.px.parallax load.px.parallax",function(){n(),h.refresh(),o.isFresh=!1,o.requestRender()}).on("scroll.px.parallax load.px.parallax",function(){l(),o.requestRender()}),n(),l(),this.isReady=!0;var p=-1;s()}},configure:function(i){"object"==typeof i&&(delete i.refresh,delete i.render,t.extend(this.prototype,i))},refresh:function(){t.each(this.sliders,function(){this.refresh()}),this.isFresh=!0},render:function(){this.isFresh||this.refresh(),t.each(this.sliders,function(){this.render()})},requestRender:function(){var t=this;t.render(),t.isBusy=!1},destroy:function(e){var s,h=t(e).data("px.parallax");for(h.$mirror.remove(),s=0;s<this.sliders.length;s+=1)this.sliders[s]==h&&this.sliders.splice(s,1);t(e).data("px.parallax",!1),0===this.sliders.length&&(t(i).off("scroll.px.parallax resize.px.parallax load.px.parallax"),this.isReady=!1,o.isSetup=!1)}});var h=t.fn.parallax;t.fn.parallax=function(s){return this.each(function(){var h=t(this),r="object"==typeof s&&s;this==i||this==e||h.is("body")?o.configure(r):h.data("px.parallax")?"object"==typeof s&&t.extend(h.data("px.parallax"),r):(r=t.extend({},h.data(),r),h.data("px.parallax",new o(this,r))),"string"==typeof s&&("destroy"==s?o.destroy(this):o[s]())})},t.fn.parallax.Constructor=o,t.fn.parallax.noConflict=function(){return t.fn.parallax=h,this},t(function(){t('[data-parallax="scroll"]').parallax()})}(jQuery,window,document);
	}
}
phoneScroll();

// ******************************
// READ MORE
// ******************************

if ($('.js-draw-trigger')[0]) {
	$(".js-draw-trigger").each(function(){
		var copy = $(this).text()
		var draw = $(this).prev();
		var openCopy = $(this).attr("data-text-swap");
		var defaultPosition = $(this).attr("data-default-position");

		if (openCopy === undefined) {
			openCopy = "Less";
		}

		if (!$(this).hasClass("open")) {
			draw.slideUp()
		} else {
			$(this).text(openCopy)
		}

		$(this).click(function() {
			if ($(this).hasClass("open")) {
				draw.slideUp();
				$(this).removeClass("open");
				$(this).text(copy)
			} else {
				draw.slideDown();
				$(this).addClass("open");
				$(this).text(openCopy)
			}
		});
	});
}


// ******************************
// NAVIGATION
// ******************************
function nav () {
	var headerHeight = $('.header').outerHeight();
	var windowHeight = $(window).height();

	if ($('.header__banner')[0]) {
		var headerBannerHeight = $('.header__banner').outerHeight();
		var headerHeight = headerHeight - headerBannerHeight;
		var navHeight = windowHeight - headerHeight - headerBannerHeight;
	} else {
		var navHeight = windowHeight - headerHeight;
	}

	$('.js-nav').css({
		'top': headerHeight + 'px',
		'height': navHeight + 'px',
	});

	$('.js-nav .nav__list').css({
		'max-height': navHeight - 100 + 'px',
	});

	// console.log("nav")
}
nav();

$('.js-nav .nav__dropdown').slideUp();
$('.js-nav .nav__dropdown').closest(".nav__item").addClass("nav__item--drop");
$('.nav__item--drop').prepend("<div class='nav__dropdown-toggle'></div>");


$(".nav__dropdown-toggle").click(function() {
	$(this).siblings(".nav__dropdown").slideToggle();
	$(this).toggleClass("nav__dropdown-toggle--active");
});

$(".js-nav-toggle").click(function() {
	$('.js-nav').toggleClass("nav--active");
	$(this).toggleClass("nav-toggle--active");
	$('html').toggleClass("fixed");
});




// ******************************
// GENERAL CARD SLIDER
// ******************************

if ($('.js-card-slider')[0]) {
	// The js-card-slider responsive sizes are also used as breakpoints in the css so remember to update both
	$('.js-card-slider').slick({
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		dots: false,
		responsive: [
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 350,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});
}


// ******************************
// NEWS CARD SLIDER
// ******************************

if ($('.js-card-slider-news')[0]) {
	// The js-card-slider-news responsive sizes are also used as breakpoints in the css so remember to update both
	$('.js-card-slider-news').slick({
		infinite: true,
		slidesToShow: 5,
		slidesToScroll: 1,
		dots: false,
		responsive: [
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 3
				}
			}
		]
	});
}

// ******************************
// OVERLAY HERO SLIDER
// ******************************

if ($('.js-overlay-slider')[0]) {
		$('.js-overlay-slider').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		autoplay: true,
		autoplaySpeed: 3000,
	});
}

// ******************************
// HERO IMAGE BLOCK SLIDER
// ******************************

if ($('.js-image-slider')[0]) {
		$('.js-image-slider').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 3000,
	});
}

// ******************************
// SLIDER ARROWS
// ******************************
$(window).on('load', function () {
	if ($('.js-card-slider-arrow')[0]) {
		// Vertically align arrows to card images
		$(".js-card-slider-arrow").each(function(){
			var imageHeight = $(this).find('img').outerHeight()
			var arrowHeight = imageHeight / 2 + "px";
			$(this).find('.slick-arrow').css('top', arrowHeight);
		});
	}

	phoneScroll();
	nav();
});


// ******************************
// ACCORDION
// ******************************

if ($('.js-accordion')[0]) {
	$(".js-accordion .accordion__heading").on('click', function() {
		$(this).parent(".accordion__item").toggleClass('active');
	});
}



// ******************************

document.onreadystatechange = function() {
	switch (document.readyState) {
		case 'loading':
			// The document is still loading.

			break;
		case 'interactive':
			// The document has finished loading. We can now access the DOM elements.
			// But sub-resources such as images, stylesheets and frames are still loading.
			// Equivalent of document.ready
			initSlidingForms();
			initProductForms();
			initAgeRestriction();
			initBasket();
			initAddresses();
			initPayment();
			initQtyButtons();
			initQtyCartUpdate();
			initAddToCart();
			initPropertyManagementCompany();
			break;
		case 'complete':
			// The page is fully loaded.
			// Equivalent of window.load

			// Inline all svg img tags
			$app.inlineSvg('.isvg');

			break;
	}
};

// Resize event
window.addEventListener('resize', function(event){
	phoneScroll();
});

// Checkout

function initPayment () {

	function init() {

		const form = $(this);

		function setGateway(e) {
			e.preventDefault();
			const id = $(this).data('switch-to-gateway');
			form.find('[name="gatewayId"]').val(id);
			form.submit();
		}

		form.find('[data-switch-to-gateway]').click(setGateway);

	}

	$('[data-payment-gateway-choice]').each(init);

}

// Basket

function initBasket() {

	function init() {

		const form = $(this);

		function removeItem(e) {

			e.preventDefault();

			const lineItemId = $(this).data('remove-item');

			form.find('input[data-remove-item="' + lineItemId + '"]').val(1);
			form.submit();

		}

		form.find('a[data-remove-item]').click(removeItem);

	}

	$('[data-basket]').each(init);

}

// Addresses

function initAddresses() {

	function init() {

		const wrapper = $(this),
			billing = wrapper.find('[data-address-type="billingAddress"]'),
			delivery = wrapper.find('[data-address-type="shippingAddress"]'),
			billingFields = billing.find('input:not([data-no-required])');

		function toggleDelivery() {

			if ($(this).is(':checked')) {
				billing.slideUp(300, function () {
					billingFields.val('').removeAttr('required');
				})
			} else {
				billing.slideDown(300, function () {
					billingFields.attr('required', 'required');
				});
			}
		}

		wrapper.find('[data-same-as]').click(toggleDelivery);
	}

	$('[data-addresses]').each(init);

}

function initPropertyManagementCompany() {
	const $dropdown = $('[data-property-management-company]');
	const $radios = $('input[name="memberPropertyManagement"]');

	if(!$radios.length) return;

	$radios.on('change', function() {
		if ($(this).val() === 'yes') {
			$dropdown.find('select:first').attr('required', 'required');
			$dropdown.removeClass('form__row--hidden');
		} else if ($(this).val() === 'no') {
			$dropdown.find('select:first').removeAttr('required');
			$dropdown.addClass('form__row--hidden');
		}
	});
}


// Product

function initProductForms() {

	function init() {

		const wrapper = $(this),
			variantElements = wrapper.find('[data-variant-id]');

		wrapper.find('[data-slider]').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false
		});

		function selectVariant() {

			const selectedVariantId = parseInt($(this).val());

			variantElements.hide();
			wrapper.find('[data-variant-id=' + selectedVariantId + ']').show();

			function filter () {
				const slideVariantId = parseInt($(this).data("slide-variant-id"));
				return slideVariantId === selectedVariantId || isNaN(slideVariantId);
			}

		}

		function addToWishlist(e) {

			e.preventDefault();

			const variant = $(this).data('add-to-wishlist');

			$('[data-add-wishlist-form="' + variant + '"]').submit();

		}

		wrapper.find('[data-variant-selector]').change(selectVariant);
		wrapper.find('[data-add-to-wishlist]').click(addToWishlist);

	}

	$('[data-product-wrapper]').each(init);

}

// age restriction overlay

function initAgeRestriction() {

	if ($('[data-product-age-restricted]').length === 0 || $app.getCookie('age-approved') !== null) {
		return;
	}

	function clickHandler(e) {

		e.preventDefault();

		$app.setCookie('age-approved', true, 30);

		overlay.removeClass('show');
		body.removeClass('overlaid');

	}

	const overlay = $('[data-age-restriction-overlay]'),
				body = $('body'),
				consent = overlay.find('[data-consent]');

	overlay.addClass('show');
	body.addClass('overlaid');

	consent.click(clickHandler);

}


// Sliding Express Forms

function initSlidingForms() {

	function init() {

		const wrapper = $(this),
				form = wrapper.find('form'),
				userFields = wrapper.find('[data-user-fields]').find('input, textarea'),
				result = wrapper.find('[data-submission-result]'),
				noSubmit = ("noSubmit" in wrapper.data());

		function resetForm() {
			userFields.val('');
			result.empty().removeClass('response-error');
		}

		function handleError() {
			result.addClass('response-error').text('Sorry, an error occurred.');
			throw Error('Unexpected form submission error.');
		}

		function handleResponse(data) {

			if ( ! data.success) {
				handleError();
			}

			form.slideUp(400);
			result.removeClass('response-error').text('Thank you.');

		}

		function showForm(e) {
			e.preventDefault();
			resetForm();
			form.slideDown();
		}

		function hideForm(e) {
			e.preventDefault();
			form.slideUp(400, resetForm);
		}

		// assumes form validated by html attributes and no further work required
		function submitForm(e) {
			if(noSubmit) return;

			e.preventDefault();

			$.ajax({
				type: form.attr('method'),
				url: form.attr('action'),
				headers: {
					"X-Requested-With": "XMLHttpRequest",
					"HTTP_X_REQUESTED_WITH": "XMLHttpRequest"
				},
				data: form.serialize(),
				dataType: "json",
				encode: true,
			})
			.done(handleResponse)
			.fail(handleError);

		}

		wrapper.find('[data-show-form]').click(showForm);
		wrapper.find('[data-hide-form]').click(hideForm);
		form.submit(submitForm);

	}

	$('[data-toggle-form]').each(init);

}

function initQtyButtons() {
	$('.js-qty-plus').on('click', function(evt) {
        evt.preventDefault();
        var $input = $(this).parent().find('input.qty--field');
        var inputMax = $input.attr('max');
        var inputVal = parseInt($input.val());
        if(!inputVal) {
            inputVal = 1;
        }

        var newVal = inputVal+1;
        if(!inputMax || (newVal <= inputMax)) {
            $input.val(newVal);
			$input.trigger('qty-updated');
            $input[0].setCustomValidity("");
        } else if(newVal > inputMax) {
            $input[0].setCustomValidity("Oops, we only have that in stock");
            $input[0].reportValidity();
        } else {
            $input[0].setCustomValidity("");
        }
    });

    $('.js-qty-minus').on('click', function(evt) {
        evt.preventDefault();
        var $input = $(this).parent().find('input');
        var inputVal = parseInt($input.val());
        if(!inputVal) {
            inputVal = 1;
        }
        var newVal = inputVal-1;
        if(newVal < 1) {
            return false;
        }
        $input.val(newVal);
		$input.trigger('qty-updated');
    });
}

function initQtyCartUpdate() {
	$('.js-qty-field').on('input qty-updated', function(evt) {
		evt.preventDefault();

		const $form = $(this).parents('form:first');
		const autoUpdate = $(this).attr('data-auto-update');

		if (!$form || (typeof autoUpdate === 'undefined' && autoUpdate === false)) {
			return;
		}

		var formData = $form.serializeArray();
		$form.addClass('loading');

		$.ajax({
			type: "post",
			url: "",
			data: formData,
			dataType: "json",
			success: function (response, status) {
				if(status === 'success') {
					window.location.reload();
				}
			},
			complete: function(response, status) {
				if(status !== 'success') {
					$form.removeClass('loading');
				}
			}
		});
	});
}

function initAddToCart() {
	$('[data-add-to-cart]').on('submit', function(evt){
		evt.preventDefault();

		const $form = $(this);
		const formData = $form.serializeArray();
		const $loadingEl = $form.closest('[data-has-loading]');

		$loadingEl.addClass('loading');

		$.ajax({
			type: "post",
			url: "",
			data: formData,
			dataType: "json",
			success: function (response) {
				$('[data-cart-qty]').text(response.cart.totalQty);
				$popout = $(`<div class="pdp__added" data-added-to-cart>${response.message}</div>`).hide();
				$form.append($popout);
				$popout.fadeIn('slow');

				setTimeout(function() {
					$('[data-added-to-cart]').fadeOut('slow', function() {
						$('[data-added-to-cart]').remove();
					});
				}, 3000);

				$loadingEl.removeClass('loading');
			}
		});
		return false;
	});
}

// Utilities and behaviours namespaced to $app
// use these functions by calling $app.method();
var $app = {
	// Allows you to query the window width against the breakpoints. These MUST match breakpoints
	// set in _vars.scss

	// Example
	//
	// if ($app.wW() >= $app.breakpoints().small) {
	//  code to run when the window hits large breakpoint
	// }
	//
	breakpoints: function() {
		obj = {
			'xsmall':	'460',
			'small': 	'640',
			'medium':	'768',
			'large':	'1024',
			'xlarge':	'1280',
			'xxlarge':	'1600'
		}

		return obj;
	},

	wW: function(){
		return window.innerWidth;
	},


	// Sets element heights to the same
	// Usually worth duplicating code in window.load and window.resize
	// Will automatically reset the height correctly on resize thanks to the line
	// .css({'height': 'auto'});
	// I usually try to use it with the class .js-height

	// Usage: $app.equalHeights('.js-height');

	// If you're using the same 'module' in multiple areas this will prevent it from
	// setting the height across all of them
	// var sameHeight = document.querySelectorAll(".js-sameheight");
	// sameHeight.forEach((e) => {
		// var children = e.querySelectorAll('.js-height');
		// $app.equalHeights(children)
	// });
	// });

	// $('.js-sameheight').each(function(){
	// 	var children = $(this).find('.js-height');
	//
	// 	$app.equalHeights(children);
	// })
	equalHeights: function(el) {
		var findElement = $(el);
		var tallest = 0;

		findElement.css({'height': 'auto'});

		// Loop over matching divs
		for(var i = 0; i < findElement.length; i++)
		{
			var ele = findElement[i];
			var eleHeight = ele.offsetHeight;
			tallest = (eleHeight>tallest ? eleHeight : tallest); /* look up ternary operator if you dont know what this is */
		}
		for(i = 0; i < findElement.length; i++)
		{
			findElement[i].style.height = tallest + 'px';
		}
	},


	// function for setting cookies
	setCookie: function(name,value,days) {
		var expires = "";
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "")  + expires + "; path=/";
	},

	// function for getting cookies
	getCookie: function(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	},

	// function to erase a cookie
	eraseCookie: function(name) {
		document.cookie = name+'=; Max-Age=-99999999;';
	},

	// function to inline an img with an svg
	// Usage: $app.inlineSvg('.isvg');
	inlineSvg: function(selector) {
		document.querySelectorAll(selector).forEach(el => {
			const imgID = el.getAttribute('id');
			const imgClass = el.getAttribute('class');
			const imgURL = el.getAttribute('src');

			fetch(imgURL).then(data => data.text()).then(response => {
				const parser = new DOMParser();
				const xmlDoc = parser.parseFromString(response, 'text/html');
				let svg = xmlDoc.querySelector('svg');

				if (typeof imgID !== 'undefined') {
					svg.setAttribute('id', imgID);
				}

				if (typeof imgClass !== 'undefined') {
					svg.setAttribute('class', imgClass + ' replaced-svg');
				}

				svg.removeAttribute('xmlns:a');

				el.parentNode.replaceChild(svg, el);
			});
		});
	}
} // end of $app
